const FooterComponent = () => {
    return (
        <footer className="w-full py-2 mt-4">
            <hr className="border-0 h-1 bg-gray-300 w-1/4 mx-auto mb-2 rounded-full shadow-md"/>
            <div className="flex justify-center items-center space-x-4 text-gray-700 text-sm whitespace-nowrap">
                <p className="flex items-center space-x-2">
                  <span>©2025 Heying Du</span>
                    {/* <span>Email: <a href="mailto:study@heyingdu.com"
                                    className="text-inherit hover:text-inherit">study@heyingdu.com</a></span>
                    <span>Tel: <a href="tel:+14153597772" className="text-inherit hover:text-inherit">+1 (415) 359-7772</a></span> */}
                    
                </p>
            </div>
        </footer>
    );
};


export default FooterComponent;